import { DateWithTimezones } from '../../common/models/status-history-chain.model';
import { MapStopActionType, MapStopType, PointData } from '../../common/models/map-tracking-points.model';

export class ShipmentLoadToGpsPointModel implements PointData {
  viewType: MapStopType;
  latitude: number;
  longitude: number;
  dateTime: DateWithTimezones;
  extId: string;
  name: string;
  address: string;
  actions: MapStopActionType[];
  sortIndex: string;
}
